module.exports = "/_next/static/images/mines7-e09478684b949572131da431f4f49064.jpg";